import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import Cookies from "@/lib/cookies";
import { createHash, randomBytes } from "crypto";
export default class PINCode {
  constructor(req, res) {
    var _config$pincode$redis, _config$pincode$redis2, _config$pincode$redis3, _config$pincode;
    this.req = req;
    this.res = res;
    this.cookies = new Cookies(req, res);
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$pincode$redis = config.pincode.redis) === null || _config$pincode$redis === void 0 ? void 0 : _config$pincode$redis.host),
      port: process.env.REDIS_PORT || ((_config$pincode$redis2 = config.pincode.redis) === null || _config$pincode$redis2 === void 0 ? void 0 : _config$pincode$redis2.port),
      keyPrefix: config.pincode.redis.prefix,
      db: (_config$pincode$redis3 = config.pincode.redis) === null || _config$pincode$redis3 === void 0 ? void 0 : _config$pincode$redis3.db
    }, (_config$pincode = config.pincode) === null || _config$pincode === void 0 || (_config$pincode = _config$pincode.redis) === null || _config$pincode === void 0 ? void 0 : _config$pincode.cluster);
  }
  generatePINCode() {
    const randomNum = () => Math.floor(Math.random() * 10);
    return Array.from(Array(4)).map(randomNum).join("");
  }
  generateToken() {
    return randomBytes(32).toString("hex");
  }
  generateHash(key) {
    return createHash("sha256").update(key).digest("hex");
  }
  getToken() {
    return this.cookies.get(config.pincode.name);
  }
  async publish(key) {
    const pin = this.generatePINCode();
    const token = this.generateToken();
    const hash = this.generateHash(key);
    await this.redis.multi().set(hash, JSON.stringify({
      pin,
      token
    })).expire(hash, config.pincode.maxAge).exec();
    this.cookies.set([{
      name: config.pincode.name,
      value: token,
      option: {
        maxAge: config.pincode.maxAge
      }
    }]);
    return pin;
  }
  async verify(value, key) {
    const token = this.getToken();
    if (!token) return false;
    const hash = this.generateHash(key);
    const json = await this.redis.get(hash);
    if (!json) return false;
    const payload = JSON.parse(json);
    return (payload === null || payload === void 0 ? void 0 : payload.pin) === value && (payload === null || payload === void 0 ? void 0 : payload.token) === token;
  }
  async delete(key) {
    const hash = this.generateHash(key);
    await this.redis.del(hash);
    const token = this.getToken();
    if (!token) return false;
    this.cookies.remove([config.pincode.name]);
  }
}